import { render, staticRenderFns } from "./uyeOdemeler.vue?vue&type=template&id=2d1141a0&scoped=true&"
import script from "./uyeOdemeler.vue?vue&type=script&lang=js&"
export * from "./uyeOdemeler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1141a0",
  null
  
)

export default component.exports